export default function Onboarding({onComplete}){
return(
<div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f5f5f3'}}>
<div style={{maxWidth:'560px',width:'100%',padding:'2rem'}}>
<div style={{textAlign:'center',marginBottom:'3rem'}}>
<h1 style={{fontSize:'32px',fontWeight:'600',color:'#1a6b4a',marginBottom:'8px'}}>Welcome to Greenroom</h1>
<p style={{fontSize:'16px',color:'#666',lineHeight:'1.6'}}>Your event production OS. Manage bookings, deals, contracts, and settlements — all in one place.</p>
</div>
<div style={{display:'flex',flexDirection:'column',gap:'16px',marginBottom:'3rem'}}>
{[
{icon:'📋',title:'Manage Events',desc:'Track every show from first contact to final settlement'},
{icon:'💰',title:'Live P&L',desc:'See projected revenue and costs at every sales benchmark'},
{icon:'📄',title:'Contracts & Settlements',desc:'Generate professional documents in seconds'},
{icon:'✉️',title:'Email Parser',desc:'Paste an email thread and let AI extract the deal details'}
].map((item,i)=>(
<div key={i} style={{display:'flex',gap:'16px',alignItems:'flex-start',background:'white',border:'1px solid #eee',borderRadius:'12px',padding:'1.25rem'}}>
<span style={{fontSize:'24px'}}>{item.icon}</span>
<div>
<p style={{fontWeight:'500',fontSize:'15px',margin:'0 0 4px'}}>{item.title}</p>
<p style={{fontSize:'13px',color:'#888',margin:0}}>{item.desc}</p>
</div>
</div>
))}
</div>
<button onClick={onComplete} style={{width:'100%',padding:'14px',background:'#1a6b4a',color:'white',border:'none',borderRadius:'10px',fontSize:'16px',fontWeight:'500',cursor:'pointer'}}>
Create Your First Event →
</button>
</div>
</div>
)}